export default __webpack_public_path__ + "9ba14e8e4eb27af965c1ce523672e601.png";